<template>
  <section class="page-container">
    <policy-list :isList="true"></policy-list>
  </section>
</template>

<script>
import policyList from '../policy/components/policyList'
import {getStatisticsDownload} from '@api/statistic'
import {downloadFile} from '@/utils/download'

export default {
  name: 'Policy',
  components:{
    policyList
  },
  data() {
    return{}
  },
  computed:{
    isDisable(){
      return false
    },
  },
  methods: {
    handlerDown() {
      this.network().getReportDownload()
    },
    network() {
      return {
        getReportDownload: async () => {
          const res= await getStatisticsDownload({
            user_type: this.user_type,
            website_type: this.website_type,
            class_id: this.class_id,
            created_start: this.date[0],
            created_end: this.date[1],
          })
          downloadFile(res)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
}
</style>
